<template>
  <div class="step-input-wrapper">
    <ul class="progress-boxs gutter-12 clearfix" id="buttons-tab">
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 1}">
        <span class="progress-box__link org-line-btn block-btn">
          1. 기본정보<label v-if="step === 1">(현재단계)</label>
          <div class="progress-arrow-circle">
            <img class="progress-box__img" src="/images/icon-right-arrow-big.png" alt="오른쪽 화살표">
          </div>
        </span>
      </li>
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 2}">
        <span class="progress-box__link org-line-btn block-btn">
          2. {{ txt.info }}<label v-if="step === 2">(현재단계)</label>
          <div class="progress-arrow-circle">
            <img class="progress-box__img" src="/images/icon-right-arrow-big.png" alt="오른쪽 화살표">
          </div>
        </span>
      </li>
      <li class="progress-box gutter-12__li grid-3--xs" :class="{active: step === 3}">
        <span class="progress-box__link org-line-btn block-btn">
          3. 등록<label v-if="step === 3">(현재단계)</label>
        </span>
      </li>
    </ul>

    <div v-if="step === 1">
      <div class="basic-form">
        <h4 class="big-label">신청자</h4>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">신청자 이름</label>
          <p class="progress__only-text">{{member.name}}</p>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">연락처</label>
          <p class="progress__only-text">{{member.phone}}</p>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">이메일</label>
          <p class="progress__only-text">{{member.email}}</p>
        </div>

        <br>
        <br>


        <div class="inline-input-group clearfix">
          <label for="chkinfoId" class="inline-input__label"><h4 class="big-label">대표자</h4></label>
          <input class="input__checkbox--with-etc" type="checkbox" id="chkinfoId" @click="chkinfo" title="신청자정보와 동일 선택" /> 신청자정보와 동일
        </div>

        <!--h4 class="big-label">대표자</h4 -->
        <div class="inline-input-group clearfix">
          <label for="booking_ceoName" class="inline-input__label">이름</label>
          <input id="booking_ceoName" type="text" class="input__text" placeholder="대표자 이름을 입력해 주세요." v-model.trim="booking.representative.name" maxlength="30" title="대표자 이름을 입력해 주세요.">
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_contect" class="inline-input__label">연락처</label>
          <input id="booking_contect" type="text" class="input__text" placeholder="대표자 연락처를 '-'를 빼고 숫자로만 입력해 주세요."
                 v-model.trim="booking.representative.phone" maxlength="30" title="대표자 연락처를 '-'를 빼고 숫자로만 입력해 주세요.">
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_email" class="inline-input__label">이메일</label>
          <input id="booking_email" type="email" class="input__text" placeholder="대표자 이메일을 입력해주세요. 예) email@naver.com"
                 v-model.trim="booking.representative.email" maxlength="50" title="대표자 이메일을 입력해주세요. 예) email@naver.com">
        </div>

        <div class="form-submit-gruop">
          <button type="button" class="form-submit__btn btn--blue-line" @click="goToStep2">다음</button>
        </div>
      </div>
    </div>

    <div v-if="step === 2">
      <div class="basic-form">
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">기관</label>
          <p class="progress__only-text">{{room.org}}</p>
        </div>
        <div class="inline-input-group clearfix">
          <label class="inline-input__label">공간</label>
          <p class="progress__only-text">{{room.name}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label for="date" class="inline-input__label">일시</label>
          <div class="gutter-10">
            <div class="gutter-10__li grid-3">
              <datepicker v-model="date" :input-class="'input__text'" language="ko"
                          :format="'yyyy-MM-dd'" id="date" @closed="setBookingDate" :disabled="state.disabled" v-if="!communityPlus"></datepicker>
              <datepicker v-model="date" :input-class="'input__text'" language="ko"
                          :format="'yyyy-MM-dd'" id="date" @closed="setBookingDate" :disabled="statePlus.disabled" v-if="communityPlus"></datepicker>
            </div>
            <div class="gutter-10__li grid-3">
              <select class="input__select" v-model="booking.startTime" title="대관 시작시간 선택" @change="setBookingDate()">
                <option v-for="n in 25" :value="getTimeValue(n)">
                  {{Math.ceil(n / 2) + 8}}:{{n % 2 === 1 ? '00' : '30'}}
                </option>
              </select>
            </div>
            <div class="gutter-10__li grid-3">
              <select class="input__select" v-model="booking.endTime" title="대관 종료시간 선택" @change="setBookingDate()">
                <option v-for="n in 25" :value="getTimeValue(n)">
                  {{Math.ceil(n / 2) + 8}}:{{n % 2 === 1 ? '00' : '30'}}
                </option>
              </select>
            </div>
          </div>
          (사용료 결제 이후 승인 예정이며, 사용료 결제는 시설 사용 2일 전까지 완료되어야 합니다.)
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_roomCharge" class="inline-input__label">{{costTitle}}</label>
          <input id="booking_roomCharge" type="number" class="input__text" :value="exCost" readonly title="booking_roomCharge 입력">
        </div>

        <div class="inline-input-group clearfix" v-if="roomItems[selectedItem]">
          <label for="booking_optionStuff" class="inline-input__label">옵션 물품 신청</label>
          <div class="gutter-10 clearfix">
            <div class="gutter-10__li grid-3 option-label">물품</div>
            <div class="gutter-10__li grid-3 option-label">가격</div>
            <div class="gutter-10__li grid-3 option-label">추가/삭제</div>
          </div>
          <div class="gutter-10 clearfix">
            <div class="gutter-10__li grid-3">
              <select id="booking_optionStuff" class="input__select" v-model="selectedItem" title="booking_optionStuff 선택">
                <option v-for="(item, index) in roomItems" :value="index">{{item.name}}</option>
              </select>
            </div>
            <div class="gutter-10__li grid-3">
              <input class="input__text input__text--readonly"
                     :value="roomItems[selectedItem].cost" readonly title="옵션 물품 신청 가격">
            </div>
            <div class="gutter-10__li grid-3">
              <button class="block-btn xs-btn btn--blue" @click="addItem" id="addBtn">추가</button>
            </div>
          </div>

          <div class="added-list">
            <h6 class="added-list__title">추가된 리스트</h6>

            <div v-for="(item, index) in optionItems" class="gutter-10 clearfix">
              <div class="gutter-10__li grid-3">
                <input type="text" class="input__text input__text--readonly"
                       :value="item.name" readonly title="추가 옵션 물품 신청 물품">
              </div>
              <div class="gutter-10__li grid-3">
                <input type="text" class="input__text input__text--readonly"
                       :value="item.cost" readonly title="추가 옵션 물품 신청 가격">
              </div>
              <div class="gutter-10__li grid-3">
                <button class="block-btn xs-btn line-btn--red" @click="delItem(index)">삭제</button>
              </div>
            </div>

            <div class="gutter-10 clearfix">
              <div class="gutter-10__li grid-3">
                <label class="option-total-label" for="booking_sum">물품비용 합계</label>
              </div>
              <div class="gutter-10__li grid-3">
                <input type="text" class="input__text input__text--total"
                       :value="addtionalCost" id="booking_sum" readonly title="물품비용 합계">
              </div>
              <div class="gutter-10__li grid-3"></div>
            </div>
          </div>
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_roomChargeTotal" class="inline-input__label">총 비용</label>
          <input id="booking_roomChargeTotal" v-model.trim="booking.totalCost" type="text" readonly="readonly" class="input__text input__text--readonly" :value="ttlCost" title="booking_roomChargeTotal 입력">
        </div>

        <div class="inline-input-group clearfix" style="margin-bottom:0px;">
          <label for="group" class="inline-input__label">단체명</label>
          <div class="gutter-10 clearfix">
            <div class="gutter-10__li grid-3">
              <input id="booking_cmKind" class="input__checkbox--with-etc" type="checkbox" v-model="checkPlus" @change="changeCheckPlus"
                   :disabled="room.status === 'COMMUNITY' || communities.length === 0" title="커뮤니티 대관 체크박스"> 커뮤니티 대관
            </div>
            <div class="gutter-10__li grid-3">
              <select class="inline-input-etc__select" :disabled="communities.length === 0"
                    v-model="communitieList" @change="selectedCommunity" title="커뮤니티 선택">
                <option v-for="item in communities" :value="item">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="inline-input-group clearfix">
          <input type="text" class="input__text" placeholder="단체명을 입력해 주세요. (30자 이하)"
               v-model.trim="booking.groupName" v-on:change="groupNameValidate" maxlength="30" id="group" title="단체명을 입력해 주세요. (30자 이하)">
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_purpose" class="inline-input__label">{{ txt.purpose }}</label>
                    	커뮤니티 외 단체의 경우 단체 성격, 단체 운영목적, {{ txt.purpose }}을 상세하게 작성 해 주시기 바랍니다.
          <div style="margin-top:5px">
            <textarea id="booking_purpose" class="input__textarea" v-model.trim="booking.purpose" maxlength="1000" title="booking_purpose 입력"></textarea>
          </div>
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_personnel" class="inline-input__label">사용인원</label>
          <input id="booking_personnel" type="number" class="input__text input__text--sm"
                 min="1" v-model.trim="booking.personnel" maxlength="8"
                 @change="checkNumber"
                 title="사용인원 입력"
                 onkeydown="javascript: if (this.value.length >= this.maxLength && (event.key >= 0 && event.key <= 9)) return false;
                     return ((event.key >= 0 && event.key <= 9) || (event.keyCode >= 8 && event.keyCode <= 46) || (event.keyCode >= 91 && event.keyCode <= 93)
                     || (event.keyCode >= 112 && event.keyCode <= 123) || (event.keyCode >= 144 && event.keyCode <= 145)
                     || (event.ctrlKey && event.keyCode == 67) || (event.ctrlKey && event.keyCode == 86)) ? true : false">
        </div>
        <div class="form-submit-gruop">
          <button type="button" class="form-submit__btn line-btn--red" @click="goToStep1">이전</button>
          <button type="button" class="form-submit__btn btn--blue-line" @click="goToStep3">다음</button>
        </div>
      </div>
    </div>
    <!-- 대관정보 끝 -->

    <!-- 등록 시작 -->
    <div v-if="step === 3">
      <div class="basic-form">
        <div for="booking_org" class="inline-input-group clearfix">
          <label id="booking_org" class="inline-input__label">기관</label>
          <p class="progress__only-text">{{room.org}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_place" class="inline-input__label">공간</label>
          <p id="booking_place" class="progress__only-text">{{room.name}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label for="booking_creatDate" class="inline-input__label">일시</label>
          <p id="booking_creatDate" class="progress__only-text">{{bookingDate}}</p>
        </div>

        <div class="inline-input-group clearfix">
          <label class="inline-input__label">총 비용(예상)</label>
          <p class="progress__only-text">
            <span class="color-blue" v-if="communityPlus">
              0원
            </span>
            <span class="color-blue" v-else-if="isPlus && checkPlus">
              0원
            </span>
            <span class="color-blue" v-else>
              {{(exCost + addtionalCost)}}원
            </span>
            ( {{ txt.cost }} {{exCost}} + 옵션물품 {{addtionalCost}}
            <template v-if="communityPlus">
              , 커뮤니티플러스 회원할인
            </template>
            <template v-else-if="isPlus && checkPlus">
              , 커뮤니티플러스 회원할인
            </template>
            )
          </p>
        </div>

        <div class="inline-input-group clearfix">
          <label class="inline-input__label">옵션물품</label>
          <div class="added-list added-list--confirm">
            <h6 class="added-list__title" style="color: #282828;">추가된 리스트</h6>
            <p v-for="item in optionItems" class="progress__only-text">{{item.name}}
              <span class="progress__only-text__price">{{item.cost}}</span></p>
          </div>
        </div>
		
		<div class="inline-input-group clearfix" v-if="room.orgCode !== 'gch'">
          <label class="inline-input__label">첨부파일</label>
          <form name="formBookingFile01" id="formBookingFile01" method="post" enctype="multipart/form-data" action="/api/file-uploads">
            <input type="file" name="file" id="bookingFile01"  ref="imgUrl" accept="image/gif, image/jpeg, image/png" v-on:change="imgUrlChange()" class="inline-input__file" title="첨부파일 선택버튼">
          </form>
          <p class="guide-text" style="color: #282828;">세금계산서 발행의 경우 사업자등록증을 첨부해 주세요.</p>
        </div>
		
        <div class="block-input-group clearfix">

		<!-- 노원50플러스센터 시설대관운영지침 -->
		<div v-if="room.orgCode === 'nwc'">
			<label class="block-input-label">노원50플러스센터 시설대관운영지침</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">1. 대관시간</p>
				<ul>
					<li>① 센터의 대관시간은 서울시50+센터 운영지침 및 센터의 운영일을 기준으로 하며, 평일에는 오전9시부터 오후9시까지, 토요일은 오전 9시부터 오후 5시까지로 한다. 단, 일요일과 법정공휴일은 휴관으로 별도 개방하지 않으며, 센터의 개방일정에 의해 유동적으로 대관할 수 있다.</li>
					<li>② 대관시간</li>
				</ul>
				<table>
					<caption>대관시간</caption>
					<colgroup>
						<col style="width:30%;">
						<col style="width:30%;">
						<col style="width:30%;">
					</colgroup>
					<thead>
						<tr>
							<th scope="col" >구분</th>
							<th scope="col" >요일</th>
							<th scope="col" class="last">대관가능기간</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>평  일</td>
							<td>월~금요일</td>
							<td class="last">9:00 ~ 21:00</td>
						</tr>
						<tr>
							<td>주  말</td>
							<td>토요일</td>
							<td class="last">9:00 ~ 17:00</td>
						</tr>
					</tbody>
				</table>
				<p class="area-box__middle-section">2. 대관취소 및 변경</p>
				<ul>
					<li>① 다음 각 호에 해당하는 때에는 대관을 취소 혹은 변경 할 수 있다.
						<ul>
							<li>- 시설사용 신청내용이 행사의 내용과 다를 때</li>
							<li>- 대관승인 조건을 위반 할 때</li>
						</ul>
					</li>
					<li>② 센터장은 대관예정인 시설공간이 천재지변 및 기타 이에 준하는 사태로 사용 할 수 없게 된 때에는 대관을 취소하고 대관통지를 받은 자에게 자체 없이 그 사실을 통지하여야 한다.</li>
					<li>③ 대관신청인은 대관취소 시, 행사 예정일 3일 전까지는 홈페이지를 통해 취소요청을 하여야 한다.  </li>
				</ul>
				<p class="area-box__middle-section">3. 대관료</p>
				<ul>
					<li>① 센터 시설의 시설운영등에 소요되는 비용을 충당하기 위해 제5조의 규정에 의하여 대관결정 승인을 받은 자는 별도로 정한 시설대관 이용료 기준에 따라 대관료를 납부하여야 하며 징수비용은 관련 자치구 조례를 기준으로 책정하되 조례변경시 변경할 수 있다.</li>
					<li>② 사용신청 취소 및 변경사항은 최소 사용일 3일 전까지 통지하여야 한다.</li>
					<li>③ 대관료 징수는 사용예정일 3일전까지는 납부하여야 한다. </li>
					<li>④ 시설 대관료는 노원50플러스센터 목적사업에 사용한다.</li>
					<li>⑤ 시설대관 이용료 기준
						<ul>
							<li>- 수시대관의 경우 관련 자치구 조례를 근거로 하며 조례변경시 변경할 수 있다.</li>
						</ul>
					</li>
				</ul>
				<table>
					<caption>시설대관 이용료 기준</caption>
					<colgroup>
						<col style="width:auto;">
						<col style="width:10%;">
						<col style="width:20%;">
						<col style="width:20%;">
						<col style="width:20%;">
						<col style="width:20%;">
						<col style="width:30%;">
					</colgroup>
					<thead>
						<tr>
							<th scope="col" rowspan="2" colspan="2">구분</th>
							<th scope="col" colspan="3">3층</th>
							<th scope="col">4층</th>
							<th scope="col" class="last">5층</th>
						</tr>
						<tr>
							<th scope="col">배움탐색실</th>
							<th scope="col">함께부엌</th>
							<th scope="col">미래설계실</th>
							<th scope="col">이음강당</th>
							<th scope="col" class="last">도시락카페</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td colspan="2">수용인원</td>
							<td>20명</td>
							<td>12명</td>
							<td>15명</td>
							<td>50명</td>
							<td class="last">스탠딩</td>
						</tr>
						<tr>
							<td colspan="2">비치물품</td>
							<td>빔프로젝트책상 · 의자냉난방</td>
							<td>조리도구 책상 · 의자냉난방</td>
							<td>빔프로젝트책상 · 의자냉난방</td>
							<td>빔프로젝트음향장비 · 마이크책상 · 의자 냉난방</td>
							<td class="last">-</td>
						</tr>
						<tr>
							<td rowspan="3">대관료</td>
							<td>3시간이내</td>
							<td>20,000원</td>
							<td>50,000원</td>
							<td>20,000원</td>
							<td>50,000원</td>
							<td rowspan="3" class="last">없음</td>
						</tr>
						<tr>
							<td>3시간~5시간</td>
							<td>30,000원</td>
							<td>70,000원</td>
							<td>30,000원</td>
							<td>70,000원</td>
						</tr>
						<tr>
							<td>5시간 초과</td>
							<td>50,000원</td>
							<td>100,000원</td>
							<td>50,000원</td>
							<td>100,000원</td>
						</tr>
						<tr>
							<td colspan="2">기타</td>
							<td colspan="4">노트북 대여 불가 / 함께 부엌은 화기 사용 불가센터 교육프로그램에 따라 대관 일정이 변경될 수 있음</td>
							<td class="last">자율이용 가능5명 이상 단체사전신청</td>
						</tr>
					</tbody>
				</table>
				<p class="area-box__middle-section">4. 사용요금 반환</p>
				<ul>
					<li>① 시설의 안전관리 및 유지보수 등 시설의 책임으로 일정기간 교육과정 및 시설을 이용할 수 없게 된 경우 : 전체금액 반환</li>
					<li>② 교육과정 취소·변경 또는 천재지변 등 부득이한 사유로 이용이 불가능하게 된 경우</li>
					<li>③ 센터의 귀책사유 및 천재지변 등의 불가항력적인 사유발생 시 : 사용료의 전체</li>
					<li>④ 과오납 징수 : 전체금액 반환</li>
					<li>⑤ 사용개시일 전일까지는 전액 반환하며, 사용개시일 당일은 반환 불가</li>
				</ul>
				<p class="area-box__middle-section">5. 대관신청제한 및 금지</p>
				<ul>
					<li>① 센터는 다음 각 호에 해당하는 자에게는 대관신청을 제한하거나 신청을 받지 않을 수 있다.
						<ul>
							<li>- 공공질서 유지 및 미풍양속 등 공익을 해하거나 사회적 통념을 위반하는 내용</li>
							<li>- 센터시설 및 설비를 심각하게 훼손할 우려가 있거나 시설 및 설비의 관리 유지상 부적절한 행사를 목적으로 하는 경우</li>
							<li>- 센터의 사용조건을 위반하거나 기존에 허위 작성으로 대관신청을 취소한 사실이 있는 경우</li>
							<li>- 승인단체 이외의 단체 등에 사용을 양도한 경우</li>
							<li>- 사회적물의를 일으킬 수 있는 소지의내용이들어있는 행사를 목적으로 하는 경우</li>
							<li>- 영리를 목적으로 하는(유료입장, 물품판매 등) 경우</li>
							<li>- 특정 종교 포교활동 또는 정치적인 목적, 영리목적의 행사인 경우 </li>
							<li>- 센터의 운영목적 또는 설립 취지 등에 위배되는 내용의 대관을 신청한 경우</li>
						</ul>
					</li>
					<li>② 센터는 다음 각 호에 해당하는 때에는 대관을 취소하거나 사용을 중지할 수 있다.
						<ul>
							<li>- 대관승인 후 신청기재 사실이 허위로 밝혀졌을 대</li>
							<li>- 센터와의 협의 없이 판매등 임의의 행사를 진행 할 때</li>
							<li>- 대관자가 대관 사용권을 제3자에게 양도 또는 전대하는 경우</li>
							<li>- 지정한 기일내 대관료를 납부하지 않았을 경우</li>
							<li>- 센터내 흡연, 음주, 위험물 사용 등 그 외 이와 유사한 행위 또는 반입한 경우 </li>
							<li>- 대관행사 종료후 사용시설물과 물품을 요구한대로 정리하지 않았을 경우</li>
							<li>- 센터내에서 다른 이용자 및 대관자에게 불편을 주는 행위를 했을 경우</li>
						</ul>
					</li>
				</ul>
				<p class="area-box__middle-section">6. 준수사항 및 개방조건</p>
				<ul>
					<li>① 시설사용의 승인된 목적에 따라 다음 각 호의 의거를 준수하여야 한다.
						<ul>
							<li>- 냉난방시설, 위험물시설, 기타 주요시설은 센터 관리자의 승인없이 임의로 사용 및 설치ㆍ철거할 수 없으며, 사용시설 내에 행사에 불필요하다고 판단되는 물품 및 허가되지 않는 각종 음식물의 반입은 금지한다. </li>
							<li>- 센터내외 시설 및 기물이 훼손되지 않도록 하여야 하고, 분실 및 훼손되었을 경우 그 손해는 대관자가 이를 변상하고, 사용한 시설설비는 행사 후 기존의 설치상태로 원상복귀 하여야 한다. </li>
							<li>- 사용자에게 피해가 가지 않도록 하며 청결 및 공공질서를 유지하며, 시설사용 중 발생하는 쓰레기는 대관자가 수거하여 분리배출 처리하고 그에 따른 비용은 대관자가 부담하여야 한다. </li>
							<li>- 시설 이용 시, 안전관리수칙을 반드시 준수하여야 하며 이를 준수하지 않은 결과로 야기된 안전사고에 대하여 대관자가 모든 책임을 진다.</li>
							<li>- 센터는 대관 중 행사와 관련하여 발생된 인적․물적사고에 대하여 손해배상을 포함한 민형사상 책임을 지지 않는다. </li>
							<li>- 시설사용자는 사용기간 중 특별한 설비가 필요한 때에는 센터 관리자의 허락을 얻어야 하며, 대관자가 가져온 부대설비 및 각종 기자재와 장비 등 이와 유사한 모든 것에 문제가 있을 시 센터는 이로 인한 손해배상이나 손실보상의 책임을 지지 않는다. </li>
							<li>- 대관자는 센터에서 제공한 컴퓨터 및 노트북 사용시 개인정보 및 단체기밀 등이 유출되지 않도록 해야하며, 센터는 정보 및 기밀 유출로 인한 손해배상이나 손실보상의 책임을 지지 않는다. </li>
							<li>- 제 13조에 의거하여 대관시설의 사용을 제한 및 취소할 경우, 대관자에게 손해가 있을지라도 센터는 그 배상책임을 지지 않는다.</li>
							<li>- 시설 내에서는 흡연 및 음주행위를 할 수 없다.</li>
							<li>- 음향사용 및 고성방가등의 행위로 인근주민들로부터 민원이 발생하지 않도록 주의한다.</li>
							<li>- 시설 대관시간은 반드시 준수하여야 한다.</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<!-- //노원50플러스센터 시설대관운영지침 -->

		<!-- 동작50플러스센터 대관운영규정 -->
		<div v-else-if="room.orgCode === 'djc'">
			<label class="block-input-label">동작50플러스센터 대관운영규정</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">1. 목적</p>
				<p>이 운영 규정은 동작50+센터(이하 ‘센터’라 한다)내 대관 지침에 관한 제반 사항 규정을 정함을 목적으로 한다.</p>
				<p class="area-box__middle-section">2. 대관 허가기준</p>
				<p>본 센터는 대관사용 신청이 접수된 순서에 따라 대관승인 심사절차를 진행하며, 본 센터 설립 목적의 적합성, 일정의 수용 가능성, 공익적인 교육 및 행사 등을 감안하여 승인 여부를 결정한다.</p>
				<p class="area-box__middle-section">3. 대관료의 반환</p>
				<ul>
					<li>사용자가 이미 납부한 대관료는 다음 각 호에 해당하는 경우를 제외하고는 이를 반환하지 아니한다.</li>
					<li>① 재해 등 천재지변, 기타 불가항력인 사유로 대관사용이 불가능한 경우, 또는 본 센터의 귀책사유로 사용이 불가능한 경우에는 기 납부한 대관료 전액을 반환한다.</li>
					<li>② 센터는 다음에 따라 사용료를 환불한다.
						<ul>
							<li>- 사용개시일 당일 : 환불불가</li>
							<li>- 사용개시일 전일까지 : 전액환불</li>
						</ul>
					</li>
				</ul>
				<p class="area-box__middle-section">4. 대관 승인불허</p>
				<ul>
					<li>센터는 다음 각 호의 1에 해당하는 경우에는 대관승인을 불허할 수 있다.</li>
					<li>① 운영 목적 또는 센터 설립 취지 등에 위배되는 내용의 대관을 신청하는 경우</li>
					<li>② 과도한 시설물의 설치로 본 센터의 시설 및 설비를 심각히 훼손할 우려가 있거나 또는 센터의 관리, 유지상 부적절한 행사를 목적으로 하는 경우</li>
					<li>③ 센터 운영에 있어 방호 및 안전에 문제가 있거나 소음, 소란, 선동 등으로 타 행사를 방해할 우려가 있는 경우</li>
					<li>④ 상품, 유료 서비스의 홍보와 판매를 주된 목적으로 하는 경우</li>
					<li>⑤ 종교적 · 정치적 · 상업적인 목적 또는 기타 불순한 목적으로 이용하는 경우</li>
				</ul>
				<p class="area-box__middle-section">5. 대관 계약해지</p>
				<ul>
					<li>① 대관승인 시 지정한 기일 내에 계약을 체결하지 않거나 대관료를 납부하지 않을 경우</li>
					<li>② 대관승인 후 대관신청의 기재사실이 허위로 밝혀졌거나, 사용 내용에 중대한 변경 사항이 있을 경우</li>
					<li>③ 대관 신청자가 대관승인 받은 사항을 타인에게 양도하거나 전대하였을 경우</li>
				</ul>
				<p class="area-box__middle-section">6. 대관 사용의무</p>
				<ul>
					<li>① 사용자는 대관 시설과 설비에 관하여 선량한 사용자로서의 주의 의무를 다해야 하며, 특히 화재 예방에 최선을 다해야 한다.</li>
					<li>② 사용자는 대관 사용 후, 모든 설비 및 설치품목에 대해 사용전과 같은 원위치로의 원상복구 의무를 갖는다.</li>
					<li>③ 시설 및 기자재 작동은 사용자가 직접 조작해야 한다.</li>
					<li>④ 사용자는 준비, 사용, 철수기간 중 발생하는 쓰레기를 직접 수거하고 반출하여야 한다.</li>
					<li>⑤ 사용자는 다음과 같은 행위를 하여서는 안 된다.
						<ul>
							<li>- 과도한 전기사용 및 음향 설비 사용으로 타 이용자의 시설물 사용을 방해하는 행위</li>
							<li>- 센터 강의실 내에서 음식물을 취사 또는 조리하거나 사전에 협의되지 않은 음식물을 반입하는 행위  </li>
						</ul>
					</li>
					<li>⑥ 사용자는 대관사용 후 담당자 또는 관계자 입회하에 시설물을 점검 받아야 한다.</li>
				</ul>
				<p class="area-box__middle-section">7. 손해 배상책임</p>
				<ul>
					<li>① 사용자가 대관 사용의무를 소홀히 하여 시설 및 설비에 대하여 손해를 발생시켰을 경우에는 지체 없이 그 손해를 배상해야 한다.</li>
					<li>② 대관기간 중(준비 및 철수기간 포함) 센터의 고의 또는 과실이 있는 경우를 제외하고는 어떠한 인적, 물적 손해에 대해서도 센터가 손해배상 책임을 지지 않는다.</li>
				</ul>
				<p>이 지침의 미숙지 및 위반으로 인해 발생하는 모든 책임은 사용자가 부담하며, 이로 인하여 상대방에게 손해를 입힐 경우에는 사용자가 이를 배상해야 한다.</p>
			</div>
		</div>
		<!-- //동작50플러스센터 대관운영규정 -->

		<!-- 서울시도심권50플러스센터 대관지침 -->
		<div v-else-if="room.orgCode === 'dsc'">
			<label class="block-input-label">서울시도심권50플러스센터 대관지침</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">제1조(목적)</p>
				<p>이 지침은 서울특별시 장년층 인생이모작 지원에 관한 조례에 근거하여 재단법인 서울특별시50플러스재단(이하 ‘재단’이라고 한다)이 서울특별시(이하 ‘시’라고 한다)로부터 위탁받아 운영하는 서울시도심권50플러스센터(이하 “센터”라 한다) 대관운영에 관한 제반사항 규정을 목적으로 한다.</p>
				<p class="area-box__middle-section">제2조(대관신청 및 제외 대상)</p>
				<p>본 센터 대관신청 승인 및 불가 대상은 다음과 같다.</p>
				<table>
					<caption>센터 대관신청 승인 및 불가 대상</caption>
					<colgroup>
						<col style="width:17%;">
						<col style="width:26%;">
						<col style="width:25%;">
						<col style="width:10%;">
						<col style="width:auto;">
					</colgroup>
					<thead>
						<tr>
							<th scope="col">대관주체</th>
							<th scope="col">승인</th>
							<th scope="col">불가</th>
							<th scope="col">대관료</th>
							<th scope="col" class="last">비고</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>서울시 및 운영법인</td>
							<td>중장년층을 대상으로 하는 공익적인 교육, 행사 등</td>
							<td>직원대상 교육, 회의 등 자체 행사</td>
							<td>무료</td>
							<td class="last">공문서 제출 시 적용가능</td>
						</tr>
						<tr>
							<td>관련 공공기관 및 민간단체</td>
							<td>중장년층을 대상으로 하는 공익적인 교육, 행사 등</td>
							<td>상업적 또는 중장년층 대상이 아닌 교육, 행사 등</td>
							<td>감면(50%)</td>
							<td class="last">협약업무의 경우 예외 적용</td>
						</tr>
						<tr>
							<td>센터 커뮤니티</td>
							<td>회원 간 소모임, 회의, 교육 등 각종 커뮤니티 활동</td>
							<td>회원 개인적인 용무나 상업적 활동</td>
							<td>무료</td>
							<td class="last">승인 등록된 커뮤니티</td>
						</tr>
					</tbody>
				</table>
				<p class="area-box__middle-section">제3조(대관가능 일자 및 시간)</p>
				<ul>
					<li>① 대관가능일자는 일요일, 공휴일을 제외한다.</li>
					<li>② 대관가능시간은 (평일) 09:00 ~ 20:30, (토요일) 09:00 ~ 16:00에 한해 가능하다.</li>
				</ul>
				<p class="area-box__middle-section">제4조(대관의 범위 및 대관료)</p>
				<ul>
					<li>① 센터 대관의 범위와 대관료는 아래와 같다.</li>
				</ul>
				<table>
					<caption>센터 대관의 범위와 대관료</caption>
					<colgroup>
						<col style="width:10%;">
						<col style="width:13%;">
						<col style="width:11%;">
						<col style="width:10%;">
						<col style="width:32%;">
						<col style="width:13%;">
						<col style="width:auto;">
					</colgroup>
					<thead>
						<tr>
							<th scope="col">층별</th>
							<th scope="col">구분</th>
							<th scope="col">수용인원<br>(명)</th>
							<th scope="col">규모(㎡)</th>
							<th scope="col">기자재 보유현황</th>
							<th scope="col">대관료(원)<br>(2시간기준)</th>
							<th scope="col" class="last">비고</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>지하1층</td>
							<td>열린마당</td>
							<td>40</td>
							<td>99㎡</td>
							<td>빔, 스크린, 전자교탁, 음향, 책상(20개), 의자(40개), 칠판</td>
							<td>50,000원</td>
							<td class="last"></td>
						</tr>
						<tr>
							<td rowspan="3">2층</td>
							<td>배움터1</td>
							<td>30</td>
							<td>72.4㎡</td>
							<td>빔, 스크린, 전자교탁, 음향, 책상(15개), 의자(30개), 칠판</td>
							<td>40,000원</td>
							<td class="last"></td>
						</tr>
						<tr>
							<td>배움터2</td>
							<td>20</td>
							<td>48.7㎡</td>
							<td>빔, 스크린, 전자교탁, 음향, 책상(10개), 의자(20개), 칠판</td>
							<td>30,000원</td>
							<td class="last"></td>
						</tr>
						<tr>
							<td>배움터3</td>
							<td>10</td>
							<td>22.8㎡</td>
							<td>빔, 스크린 책상(3개), 의자(12개), 칠판</td>
							<td>20,000원</td>
							<td class="last"></td>
						</tr>
						<tr>
							<td rowspan="2">8층</td>
							<td>이룸터</td>
							<td>18</td>
							<td>40.8㎡</td>
							<td>빔, 스크린 책상(10개), 의자(20개), 칠판</td>
							<td>30,000원</td>
							<td class="last"></td>
						</tr>
						<tr>
							<td>작은목공실</td>
							<td>10</td>
							<td>40.4㎡</td>
							<td>책상(5개), 의자(10개), 전동실톱, 탁상드릴 등</td>
							<td>50,000원</td>
							<td class="last">*기계 사용료 포함</td>
						</tr>
					</tbody>
				</table>
				<ul>
					<li>
						<p>※ 비 고</p>
						<ul>
							<li>1) 야간, 주말의 공연 및 행사에 대하여는 기준액의 100분의 20을 가산함.</li>
							<li>2) 초과사용료 가산
								<ul>
									<li>- 1시간미만 : 기본사용료의 100분의 50</li>
									<li>- 1시간 이상 2시간미만 : 기본사용료 전액</li>
								</ul>
							</li>
							<li>3) 공간 내 부대시설(프로젝터, 음향시설) 사용가능 함.
								<ul>
									<li>- 단, 대관 희망 공간 내 부대시설(프로젝터, 음향시설) 이용 시, 사전에 문서로 사용승인을 받아야 하며, 기자재 고장   시 수선(수리비)료 각 단체가 부담 함.</li>
								</ul>
							</li>
							<li>4) 기자재 보유현황에 명시된 기자재 외 추가 기자재는 대여가 불가능 함</li>
						</ul>
					</li>
				</ul>
				<p class="area-box__middle-section">제5조(대관신청 절차)</p>
				<ul>
					<li>① 대관을 희망할 경우 본 센터 홈페이지(50plus.or.kr/dsc)를 통해 대관희망일 최소 2주전에 신청한다(대관신청은 본 센터 홈페이지를 통해 신청하는 것을 원칙으로 하며 유선 및 방문 신청은 불가하다). 단, 본 센터의 사업 추진 준비기간에는 대관승인을 유예할 수 있다.</li>
					<li>② 홈페이지 대관신청 기입사항에 누락되는 사항이 없도록 상세하게 기입한다.</li>
				</ul>
				<p class="area-box__middle-section">제6조(대관심의)</p>
				<p>대관심의 절차는 아래와 같다.</p>
				<table>
					<caption>대관심의 절차</caption>
					<colgroup>
						<col style="width:28%;">
						<col style="width:8%;">
						<col style="width:28%;">
						<col style="width:8%;">
						<col style="width:28%;">
					</colgroup>
					<thead>
						<tr>
							<th scope="col">1</th>
							<th scope="col"></th>
							<th scope="col">2</th>
							<th scope="col"></th>
							<th scope="col">3</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>대관신청</td>
							<td rowspan='2'>⇨</td>
							<td>대관심의</td>
							<td rowspan='2'>⇨</td>
							<td class="last">대관가능여부 통보</td>
						</tr>
						<tr>
							<td>센터 홈페이지 대관신청(각 항목 기입사항 누락여부 확인 등)</td>
							<td>
								신청기관 등 적격여부</br>
								대관목적 적격여부</br>
								대관일정 가능여부</br>
								센터운영 목적 부합여부</br>
							</td>
							<td class="last">대관가능여부 통보</td>
						</tr>
					</tbody>
				</table>
				<p class="area-box__middle-section">제7조(대관승인)</p>
				<ul>
					<li>① 대관승인은 본 센터 홈페이지 신청내역 확인 후 담당부서에서 결정한다.</li>
					<li>② 담당부서에서는 대관신청 접수 후 3일 이내에 심의하여 승인가부를 결정한다.</li>
					<li>③ 대관승인 시 대관료는 대관일 5일전까지 센터 계좌(우리은행 1005-402-909417 / 예금주 : 서울시도심권50플러스센터)로 납부한다(기한 내 미납 시 대관승인이 취소된다)</li>
				</ul>
				<p class="area-box__middle-section">제8조(대관승인 제한)</p>
				<p>다음 각 호에 해당하는 사유가 있는 경우에는 대관을 승인하지 않는다.</p>
				<ul>
					<li>① 특정종교의 포교 또는 정치적 · 상업적인 목적의 경우</li>
					<li>② 본 센터의 명예를 해할 우려가 있을 경우</li>
					<li>③ 신청자격이 정지중인 자가 신청하였을 경우</li>
					<li>④ 센터의 관리, 운영에 지장이 있을 경우</li>
					<li>⑤ 센터와 사용계획이 중복될 경우</li>
					<li>⑥ 기타 부적당하다고 인정할 경우</li>
				</ul>
				<p class="area-box__middle-section">제9조(대관취소 및 해지)</p>
				<p>다음 각 호에 해당하는 경우 대관허가 취소 및 해지를 할 수 있다.</p>
				<ul>
					<li>① 대관허가 후 대관신청서의 기재사실이 허위로 밝혀졌거나, 사용 내용 중에 중대한 변경사항이 있을 때</li>
					<li>② 대관허가 시 지정한 기일 내에 대관료를 납부하지 않을 때</li>
					<li>③ 대관자가 대관허가 받은 사항을 타인에게 양도하거나 전대하였을 경우</li>
					<li>④ 공간별 사용수칙과 대관계약에 위배되는 행위를 하였을 경우</li>
				</ul>
				<p class="area-box__middle-section">제10조(대관계약 취소)</p>
				<p>대관자는 대관취소를 원할 경우 사용일의 일부 또는 전체를 취소할 수 있으며, 다음 각 호에 따라 대관료의 전부 또는 일부를 반환한다.</p>
				<ul>
					<li>1. 100% 반환 : 천재지변, 기타 불가항력에 의해 대관취소, 사용일로부터 15일 이전에 대관을 취소하는 경우</li>
					<li>2. 80% 반환 : 사용일 14일 이전부터 7일 이전까지의 기간 동안 대관을 취소하는 경우</li>
					<li>3. 60% 반환 : 사용일 6일 이전부터 1일 이전까지의 기간 동안 대관을 취소하는 경우</li>
					<li>4. 50% 반환 : 사용기간 중 남은 기간에 대하여 대관취소 신청을 하는 경우</li>
				</ul>
				<p class="area-box__middle-section">제11조(사용내용 변경)</p>
				<p>대관자는 계약내용에 변경이 있을 경우 계약된 사용일로부터 15일 이전에 대관변경신청서를 제출하여 사전에 허가를 받아야 한다. 신청 내용에 따라 대관허가를 취소 또는 제한할 수 있다.</p>
				<p class="area-box__middle-section">제12조(시설사용원칙)</p>
				<p>대관자는 대관취소를 원할 경우 사용일의 일부 또는 전체를 취소할 수 있으며, 다음 각 호에 따라 대관료의 전부 또는 일부를 반환한다.</p>
				<ul>
					<li>① 대관자는 현수막, 홍보 안내물 및 가설물의 설치 또는 특수한 장비의 반입이 있는 경우 사전 허가를 받아야 한다. 허가받지 않은 설치물과 장비는 임의로 철거할 수 있다.</li>
					<li>② 대관자는 사용 종료 후 설치물을 철거하여야 하며, 설치 및 철수로 인해 기존 시설물, 설비에 손상을 가져온 경우는 변상하여야 한다.</li>
					<li>③ 대관자는 사전허가 없이 센터 내에 상업적 목적의 어떠한 설치물도 설치할 수 없다.</li>
				</ul>
				<p class="area-box__middle-section">제13조(관리의무 및 손해배상)</p>
				<ul>
					<li>① 대관자는 대관 시설과 설비에 관하여 선량한 사용자로서의 주의 의무를 다해야 하며, 특히 화재 예방에 최선을 다해야 한다.
						<ul>
							<li>1. 대관 시설과 설비에 대한 원상복구의 의무</li>
							<li>2. 화기 사용 금지의 의무</li>
							<li>3. 운영 시간 및 준비와 철수를 포함한 대관 이용시간 엄수의 의무</li>
						</ul>
					</li>
					<li>② 대관자는 다음과 같은 행위를 하여서는 안 된다.
						<ul>
							<li>1. 과도한 전기 및 음향 사용으로 타 이용자의 사용을 방해하는 행위</li>
							<li>2. 음식물을 취사 또는 조리하거나 사전에 협의되지 않은 다량의 음식물을 반입하는 행위</li>
							<li>3. 협의하지 않은 물품 반입 및 타이용자의 사용을 방해하는 행위</li>
						</ul>
					</li>
					<li>③ 대관자가 제1항의 관리의무를 소홀히 하여 시설 및 설비에 대하여 손해를 발생시켰을 경우에는 지체 없이 그 손해를 배상해야 한다.</li>
					<li>④ 대관자는 공간이용 수칙을 준수해야 하며 준수하지 않은 결과로 발생된 안전사고에 대한 민․형사상 책임을 진다.</li>
					<li>⑤ 대관자는 준비, 사용, 철수기간 중 발생하는 쓰레기를 직접 수거하고 반출하여야 한다.</li>
				</ul>
				<p class="area-box__middle-section">제14조(입장제한)</p>
				<p>본 센터는 다음 각 호에 해당하는 자에 대해서는 입장을 거절하거나 퇴장을 명할 수 있다.</p>
				<ul>
					<li>① 타인이 혐오할 만한 결함이 있거나 전염병 질환이 있는 자</li>
					<li>② 술에 취한 자</li>
					<li>③ 타인에게 위험을 주거나 방해가 될 물품을 휴대한 자</li>
					<li>④ 기타 본 센터 운영에 있어 지장이 있다고 인정되는 자</li>
				</ul>
				<p class="area-box__middle-section">제15조(이 규정에 정하지 않은 사항)</p>
				<p>이 규정에 정하지 않은 사항과 규정의 해석에 관하여는 서울특별시 인생이모작 지원에 관한 조례 및 동 시행규칙, 관계 법령 또는 선량한 풍속 기타 사회질서 등 관례에 따른다.</p>
				<p class="area-box__middle-section">제16조(규정 미숙지 및 규정 위반 시의 책임)</p>
				<ul>
					<li>① 이 규정의 미숙지 및 규정 위반으로 인해 발생하는 모든 책임은 대관자가 부담하며, 이로 인하여 상대방에게 손해를 입힐 경우에는 대관자가 이를 배상한다.</li>
					<li>② 규정 위반에 대한 시정 요청 불이행시 즉시 대관행사 종료 및 강제 퇴장에 응한다.</li>
				</ul>
			</div>
		</div>
		<!-- //서울시도심권50플러스센터 대관지침 -->

		<!-- 서대문50플러스센터 시설대관운영지침 -->
		<div v-else-if="room.orgCode === 'sdm'">
			<label class="block-input-label">서대문50플러스센터 시설대관운영지침</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">1. 대관시간</p>
				<ul>
					<li>• 월~금 10:00 ~ 20:00</li>
					<li>• 토요일 11:00 ~ 13:00</li>
					<li>• 일요일 및 공휴일은 센터 휴관</li>
				</ul>
				<br>
				<p class="area-box__middle-section">2. 대관 신청 및 대관료 납부</p>
				<ul>
					<li>① 사용자가 온라인 신청 후 일정 검토, 대관료 납부 후 사용승인</li>
					<li>② 대관 2일 전까지 신청 가능</li>
					<li>③ 대관시스템을 이용한 카드결제와 무통장 입금 중 택 1</li>
					<li>※ 미입금 시 대관이 취소될 수 있습니다.</li>
					<li>④ 대관은 접수된 순서에 따라 승인심사 절차를 진행하며, 센터의 설립목적의 적합성, 센터 일정에 따라 최종 승인을 결정합니다.</li>
					<li>※ 대관 신청을 하셨어도 대관 목적에 따라 반려될 수 있습니다.</li>
					<li>⑤ 준비, 정리시간까지 포함해서 신청해주시기 바랍니다.</li>
				</ul>
				<br>
				<p class="area-box__middle-section">3. 공간별 이용금액</p>
				<ul>
					<li>① 야간, 휴일 대관의 경우, 냉난방기 사용할 경우 대관료의 30%가 가산되어 부과됩니다.</li>
					<li>② 이용시간은 최소 2시간 기본이며, 추가 1시간당 이용료가 가산되어 부과됩니다.</li>
          <li>③ 공간별 이용금액은 홈페이지 참조</li>
				</ul>
				<p class="area-box__middle-section">4. 대관 취소 및 환불절차</p>
				<ul>
					<li>① 대관을 취소할 경우, 취소신청서를 제출해야 하며, 환불은 사용개시일 전(23:59)까지 100%, 당일 취소시 환불되지 않습니다.</li>
					<li>② 환불시 규정된 카드수수료 혹은 이체수수료가 발생할 수 있으며 공제 후 지급됩니다.</li>
				</ul>
				<br>
				<p class="area-box__middle-section">5. 대관 주의사항</p>
				<ul>
					<li>① 대관하신 공간을 이용하기 전 사무실을 방문해주세요.</li>
					<li>② 정치적, 종교적, 영리적 목적 사용은 대관이 불가합니다.</li>
					<li>③ 우리 센터의 교육일정이 확정되지 않은 기간의 경우, 사전 협의되지 않은 장기 대관은 승인이 취소될 수 있습니다.</li>
					<li>④ 참가자 통제가 불가능하거나 심한 소음, 진동 등으로 인해 센터 운영에 방해를 줄 수 있는 경우, 대관 주의사항을 준수하지 않은 경력이 있는 단체 또는 개인의 경우 대관이 제한될 수 있습니다.</li>
					<li>⑤ 센터 내에서 협의되지 않은 음식물 섭취는 불가하오니 양해바랍니다.</li>
					<li>⑥ 별도 주차공간이 없으니 인근 공영주차장을 이용해 주세요.</li>
				</ul>
				<br>
				<p class="area-box__middle-section">6. 대관 기본수칙(약정)</p>
				<ul>
					<li>① 사용 중 시설물의 손상과 화재, 도난 등 사고에 의한 피해에 대해 신청자는 책임지고 원상복구 또는 배상을 해야 합니다.</li>
					<li>② 허가없이 공간의 비품을 이동, 변경할 수 없으며, 사용 후 대관 담당자의 확인을 받은 후 사용을 종료해야 합니다.</li>
					<li>③ 사전 협의없이 10분 이상 대관시간이 초과되는 경우, 이용료 기준에 따라 대관료가 추가로 부과 될 수 있습니다.</li>
				</ul>
				<br>
				<p class="area-box__middle-section">7. 문의</p>
				<ul>
					<li>• 운영지원팀 : 02)394-5060 (직통: 070-5220-3872)</li>
				</ul>
			</div>
		</div>
		<!-- //서대문50플러스센터 시설대관운영지침 -->
		
		<!-- 성북50플러스센터 시설대관운영지침 -->
		<div v-else-if="room.orgCode === 'sbc'">
			<label class="block-input-label">성북50플러스센터 대관규정</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">제1조(목적)</p>
				<ul>
					<li>이 규정은 성북50플러스센터(이하 “센터”라 한다) 운영규정 제4조 및 제30조에 규정하는 바에 따라 </li>
					<li>센터의 시설 및 부대품을 대관 ‧ 대여하여 지역 내 행사에 사용할 수 있게 함으로써 센터의 효율적인 운영과 </li>
					<li>이용자 및 지역 주민의 복지증진에 이바지하는 것을 목적으로 한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제2조(용어의 정리)</p>
				<ul>
					<li>대관 ‧ 대여에 대해 사용하는 용어의 정의는 다음과 같다.</li>
					<li>1. 대관: 공연, 연습, 전시, 행사, 회의 등을 위하여 시설, 부대품(설비 및 부대시설)을</li>
                    <li>&emsp;&emsp;&emsp;&ensp;센터가 정한 소정의 절차를 거쳐 임대 사용하는 것</li>
					<li>2. 사용자: 센터의 대관 승인을 받아 센터와 대관 계약을 체결한 사람이나 단체</li>
				</ul><br/>
				<p class="area-box__middle-section">제3조(적용범위)</p>
				<ul>
					<li>대관은 신청 시기 및 목적에 따라 다음 각 호로 구분한다.</li>
                    <li>1. 정기대관은 센터의 운영상황에 따라 차기년도 이후 시기의 대관도 신청할 수 있다.</li>
					<li>2. 수시대관은 프로그램이 운영되지 않을 경우 잔여 시간에 대해 수시로 이루어지는 대관을 말한다.</li>
                    <li>3. 대관은 사용 목적에 따라 일반대관, 강좌대관, 커뮤니티대관, 기타대관 등으로 구분된다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제4조(대관의 범위)</p>
				<ul>
					<li>센터가 대관할 수 있는 시설의 범위는 다음 각 호와 같다.</li>
					<li>1. 3층: 두근두근 오피스(인큐베이팅룸), 보글보글 키친(요리교실), 북적북적 카페(북카페)</li>
					<li>2. 4층: 강의실1, 강의실2, 강의실3</li>
					<li>3. 부대품: 빔프로젝터, 냉 ‧ 난방, 마이크(핀마이크, 무선마이크, 유선마이크) 등</li>
					<li>&nbsp;&emsp;&emsp;&emsp;&emsp;기본시설 이외의 공간과 기본시설에 부속된 설비 및 장비. 단, 노트북 대여 불가</li>
				</ul><br/>
				<p class="area-box__middle-section">제5조(대관의 신청)</p>
				<ul>
					<li>센터의 기본시설 및 부대시설을 대관 ․ 대여하고자 하는 자(이하 “사용자”라 한다)는 대관신청서를</li>
					<li>작성하여 7일 전까지 센터에 제출 및 홈페이지를 통해 신청하여야 한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제6조(대관의 승인)</p>
				<ul>
					<li>① 센터는 대관 사용 신청이 접수된 순서에 따라 이를 심사, 대관승인 가부 결과를 통지하여야한다.</li>
					<li>② 대관의 승인 기준은 센터가 대관 시설 운영실태 및 차기년도 운영방침 등을 고려하여 객관적으로 정한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제7조(대관의 제한)</p>
				<ul>
					<li>센터는 다음 각 호에 해당하는 경우에 대관신청을 제한한다.</li>
					<li>1. 센터의 운영 목적 또는 설립 취지 등에 위배되는 내용으로 신청하는 경우</li>
					<li>2. 센터의 시설 및 설비를 훼손할 우려가 있거나 센터의 관리유지상 부적절한 행사를 목적으로 하는 경우</li>
					<li>3. 신청자격이 정지 중인 자가 신청한 경우</li>
					<li>4. 특정(종교, 정치, 사적 영리, 노점 등) 목적의 행사인 경우</li>
					<li>5. 지정 기일 내에 대관신청서를 제출하지 않았거나 사용료를 납부하지 않았을 경우</li>
					<li>6. 대관 사용권을 무단으로 타인에게 양도 또는 전대하였을 경우</li>
					<li>7. 대관 계약 후 대관 일정을 무단으로 변경하였을 경우</li>
					<li>8. 본 대관 규정을 준수하지 않았을 경우</li>
				</ul><br/>
				<p class="area-box__middle-section">제8조(사용료 등)</p>
				<ul>
					<li>사용료는 운영비, 감가상각비 등을 고려하여 센터 내에서 정하며 사용료는 아래와 같다.</li>
				</ul>
				<table>
					<caption>공간 이용금액</caption>
					<colgroup>
						<col style="width:10%;">
						<col style="width:10%;">
						<col style="width:20%;">
						<col style="width:20%;">
						<col style="width:20%;">
						<col style="width:20%;">
					</colgroup>
					<tr>
						<th scope="col" colspan="2" rowspan="2">구분</th>
						<th scope="col">3층</th>
						<th scope="col" class="last" colspan="3">4층</th>
					</tr>
					<tr>
						<td>보글보글 키친</td>
						<td>강의실 1</td>
						<td>강의실 2</td>
						<td class="last">강의실 3</td>
					</tr>
					<tr>
						<td colspan="2">면적</td>
						<td>40.16㎡</td>
						<td>40.16㎡ 66.18㎡</td>
						<td>65.64㎡</td>
						<td class="last">51.84㎡</td>
					</tr>
					<tr>
						<td colspan="2">수용인원</td>
						<td>12명</td>
						<td>30명</td>
						<td>30명</td>
						<td class="last">20명</td>
					</tr>
					<tr>
						<td colspan="2">부대설비</td>
						<td>인덕션<br/>조리도구<br/>냉 ‧ 난방</td>
						<td>빔프로젝트<br/>책상 ‧ 의자<br/>음향장비 ‧ 마이크<br/>냉 ‧ 난방</td>
						<td>빔프로젝트<br/>책상 ‧ 의자<br/>음향장비 ‧ 마이크<br/>냉 ‧ 난방</td>
						<td class="last">빔프로젝트<br/>책상 ‧ 의자<br/>음향장비 ‧ 마이크<br/>냉 ‧ 난방</td>
					</tr>
					<tr>
						<td rowspan="3">대관료</td>
						<td>3시간 이내</td>
						<td>50,000</td>
						<td>30,000</td>
						<td>30,000</td>
						<td>30,000</td>
					</tr>
					<tr>
						<td>3시간 ~ 5시간</td>
						<td>70,000</td>
						<td>50,000</td>
						<td>50,000</td>
						<td>50,000</td>
					</tr>
					<tr>
						<td>5시간 초과</td>
						<td>100,000</td>
						<td>80,000</td>
						<td>80,000</td>
						<td>80,000</td>
					</tr>
				</table>
				<ul>
					<li>※ 두근두근오피스의 대관 및 북적북적카페의 대관은 계약서에 근거하여 운영</li>
					<li>※ 5시간 초과 사용의 경우 센터 운영 시간 내에서만 가능</li>
					<li>※ 마이크의 경우 보유 수량의 미사용 시 대여 가능(보유수량: 대관 신청서 참조)</li>
					<li>※ 노트북 및 레이저포인터 대여 불가, 지참 필요</li>
					<li>※ 센터 교육 프로그램에 따라 대관 일정이 변경될 수 있음</li>
					<li>※ 대관 시간은 평일(월~금) 10:00~20:00, 주말(토) 10:00~17:00이며, 일요일 및 법정공휴일은 휴무</li>
				</ul><br/>
				<p class="area-box__middle-section">제9조(사용료의 특례 및 감면)</p>
				<ul>
					<li>센터는 제한 없이 사용자에게 동일한 사용료를 징수한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제10조(사용료의 반환)</p>
				<ul>
					<li>사용료를 납부한 사람은 다음 각 호에 해당하는 경우에 센터는 사용료를 반환할 수 있다.</li>
					<li>1. 센터의 특별한 사정에 의하여 사용이 취소되거나 정지된 경우</li>
					<li>2. 천재지변 또는 그밖에 불가항력적인 사유로 인하여 시설 사용이 불가능한 경우</li>
					<li>3. 사용허가 후 사용예정일 3일 전에 취소할 경우 전날까지 취소 시 100% 환불, 당일 취소 시 환불 불가</li>
				</ul><br/>
				<p class="area-box__middle-section">제11조(내용의 변경)</p>
				<ul>
					<li>① 사용자는 대관 사용권을 타인에게 양도 또는 전대하지 못한다.</li>
					<li>② 사용자는 대관 계약 후 임의로 내용 자체를 변경하여 진행할 수 없다. 단, 내용의 변경이 불가피할 경우 센터의 사전 승인을 받아야 한다.</li>
					<li>③ 사용자는 대관 계약 후 대관 일정을 변경할 수 없다. 다만, 상당한 사유가 있을 경우 센터의 승인을 받아야 한다.</li>
					<li>④ 사용자는 시설 및 설비에 변경을 가하거나 특별한 설비를 반입 ‧ 설치할 경우 센터의 사전 승인을 받아야 한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제12조(입장제한)</p>
				<ul>
					<li>센터는 다음 각 호에 해당하는 경우에는 사용자에게 참여자(대관실에 입장하고자 하는 사람)의 입장을 </li>
					<li>거절하게 하거나 퇴장을 명하게 할 수 있다.</li>
					<li>1. 타인에게 유해한 행위를 하는 사람 또는 전염성 질환이 있는 사람</li>
					<li>2. 위험성이 있거나 타인에게 방해가 될 우려가 있는 물품을 휴대한 사람</li>
					<li>3. 기타 센터가 안전과 질서유지를 위하여 시설의 사용을 제한할 필요가 있다고 인정되는 자</li>
				</ul><br/>
				<p class="area-box__middle-section">제13조(사용자의 의무 및 배상책임)</p>
				<ul>
					<li>① 사용자는 대관기간 중 센터의 시설 및 설비에 관하여 선량한 사용자로서의 주의 의무를 다하고, 센터가 정하는 안전관리 수칙을 준수해야 한다.</li>
					<li>② 사용자가 전항의 관리의무를 소홀히 하여 시설 및 설비에 대하여 훼손하거나 멸실하였을 때에는 그 손해를 배상하거나 원상으로 회복하여야 한다.</li>
					<li>③ 센터는 대관기간 중 대관행사와 관련하여 발생한 어떠한 인적, 물적 손해에 대하여서도 손해배상 책임을 지지 않는다. 다만 센터에게 고의 또는 중과실이 있는 경우에는 직접적인 손해의 범위 내에서 책임을 부담한다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제14조(시용자의 안전관리)</p>
				<ul>
					<li>① 사용자가 행사, 작품전시 등을 위하여 설치하는 외부장치나 시설물은 화재예방, 소방시설 설치‧유지 및 안전관리에 관한 법률(약칭: 소방시설법)을 기준으로 하여 해당 법률에 저촉되지 않는 것으로 허가한다.</li>
					<li>② 센터는 공연이나 행사 시 화재발생 우려가 있는 폭죽, 총기 등 화약류 사용을 제한 할 수 있다.</li>
					<li>③ 제1항 및 제2항의 규정을 위반한 자에 대하여 센터는 시설사용 제한을 명령할 수 있으며 이로 인한 손해배상이나 손실보상의 책임을 지지 아니하며 사용자는 이의를 제기할 수 없다.</li>
				</ul><br/>
				<p class="area-box__middle-section">제15조(사용자의 설비)</p>
				<ul>
					<li>① 사용자가 사용기간 중 특별한 장치와 설비(이하 “시설물”이라 한다)를 하고자 할 때는 미리 센터의 승인을 받아 사용자 부담으로 시설물을 설치하도록 할 수 있다.</li>
					<li>② 제1항의 규정에 의하여 시설물을 설치하였을 때에는 사용기간 만료와 동시에 이를 철거하고 원상복구 하여야 한다.</li>
					<li>③ 사용자가 제2항의 규정에 의한 의무를 이행하지 아니할 때에는 이를 센터에서 직접 원상복구하고 그 비용을 사용자로부터 징수한다. 만약 센터가 철거할 시 파손에 대한 책임을 지지 않는다.</li>
				</ul><br/>
			</div>
		</div>
		<!-- //성북50플러스센터 시설대관운영지침 -->
		
		<!-- 금천50플러스센터 시설대관운영지침 -->
		<div v-else-if="room.orgCode === 'gch'">
			<label class="block-input-label">금천50플러스센터 대관규정</label>
			<div class="text-area-box">
				<p class="area-box__middle-section">대관 규정</p>
				<br>
	            <ul>1. 신청대상
	              <li>&nbsp;&nbsp;1) 지역 단체 및 개인</li>
	              <li>&nbsp;&nbsp;2) 금천구민 및 50+세대 이용자 우선</li>
	              <li>&nbsp;&nbsp;3) 1회성 사업에 대해서만 대관 가능</li>
	            </ul>
	            <br>
	            <ul>2. 신청방법
	              <li>&nbsp;&nbsp;1) 센터 홈페이지(https://50plus.or.kr/gch)를 통해 신청 가능하며, 전화 및 방문 접수는 불가하다.</li>
	              <li>&nbsp;&nbsp;2) 신청 접수는 대관 희망일 기준 2주 전까지 가능하다.</li>
	              <li>&nbsp;&nbsp;3) 센터 설립 목적의 적합성 및 센터 프로그램 일정을 고려하여 대관 승인 여부를 결정한다.</li>
	            </ul>
	            <br>
	            <ul>3. 대관 장소
	              <li>&nbsp;&nbsp;1) 금천50플러스센터 내 강의실, 동아리실에 한한다.</li>
	              <li>&nbsp;&nbsp;2) 대관 장소 이용 시 정규 수업을 우선으로 한 후 대관 장소를 지정한다.</li>
	            </ul>
	            <br>
	            <ul>4. 대관료
          		<table><caption>공간 대관 사용료 안내</caption>
	              <thead>
	                <tr>
	                  <th colspan="2">구분</th>
	                  <th>기준시간</th>
	                  <th>금액</th>
	                  <th>비고</th>
	                </tr>
	              </thead>
	              <tbody>
	                <tr>
	                  <td rowspan="3">강의실</td>
	                  <td>6층 늘솜부엌(요리교실) 12인</td>
	                  <td rowspan="4">2시간</td>
	                  <td>30,000원</td>
	                  <td rowspan="4">◦ 초과 시간 당<br>50% 가산</td>
	                </tr>
	                <tr>
	                  <td>6층 배움터1(강의실) 24인</td>
	                  <td>15,000원</td>
	                </tr>
	                <tr>
	                  <td>7층 배움터3(강의실) 16인</td>
	                  <td>15,000원</td>
	                </tr>
	                <tr>
	                  <td>동아리실</td>
	                  <td>6층 배움터2(동아리실) 8인</td>
	                  <td>10,000원</td>
	                </tr>
	              </tbody>
	            </table>
	            </ul>
	            <br>
	            <ul>5. 환불 및 면제
	              <li>&nbsp;&nbsp;1) 접수는 홈페이지 내 온라인 접수를 통해서만 가능하며, 방문 및 유선으로는 불가능하다.</li>
	              <li>&nbsp;&nbsp;2) 신청방법 : (1) 마이페이지 → (2) 대관 내역 확인 및 대관 취소 → (3) 취소 사유 입력 → (4) 은행·계좌번호 작성 → (5) 신청자 명과 예금주 동일 여부 확인 → (6) 카드 결제 경우에도 계좌번호 작성</li>
	              <li>&nbsp;&nbsp;3) 환불기준</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(1) 전액 환불 : 대관일 기준 3일 전 취소</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(2) 대관 비용의 1/2 : 대관일 기준 1~2일 전 취소</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(3) 반환하지 아니함. 대관 당일 취소</li>
	              <li>&nbsp;&nbsp;4) 면제 : 공공기관 및 유관기관 대관요청 공문 접수(자체 심사 후 면제 여부 결정)</li>
	              <li>&nbsp;&nbsp;5) 환불 금액은 원단위 절상하여 지급한다.</li>
	              <li>&nbsp;&nbsp;6) 취소로 인한 반환금이 발생할 경우 반환 사유 발생일로부터 동조 3항의 기준에 따라 운영일 기준 7일 이내 지급한다.</li>
	            </ul>
	            <br>
	            <ul>6. 환불 및 면제
	              <li>&nbsp;&nbsp;1) 제한사항</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(1) 질서유지, 시설관리 상 문제가 있다고 판단될 경우는 대관하지 않을 수 있다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(2) 혐오 분위기 조성자, 전염병자, 질병자, 만취자, 무단출입자 등 타인에게 공공의 피해가 있을 경우는 센터 출입을 통제할 수 있다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(3) 강의실은 물 음료 제외 음식물 반입을 금지한다.<br>(단 행사의 목적 등을 고려하여 사전협의을 통해 승인이 된 경우 반입이 허용될 수 있다.)</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(4) 규정 미준수 또는 심의에 부적절하다고 판정될 시 시설 이용을 할 수 없다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(5) 정치활동, 영리활동 및 특정 종교활동 등의 행사에는 대관할 수 없다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(6) 센터 내 보유 장비 및 시설의 외부 임대 사용 또는 대행(용역 포함)을 할 수 없다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(7) 대관 신청 이용권의 임의 양도 및 전대는 할 수 없다.</li>
	              <li>&nbsp;&nbsp;2) 대관자의 의무</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(1) 센터 공간과 물품을 항상 청결하게 사용하거나 유지해야 한다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(2) 대관시간 종료 시까지 정리 정돈을 마치고 퇴실한다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(3) 대관 목적 이외의 행사를 하여서는 아니 된다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(4) 센터 내 영상음향장비 등 기자재 사용 시에는 담당 직원의 확인 및 지시에 따라야 한다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(5) 대관 시 사용한 시설 및 장비 훼손 시 원상복구 및 손해배상의 의무가 있다.<br>(손해배상 시 이용자가 5일 이내에 동일한 물품 또는 그에 상당하는 현금으로 배상해야 한다.)</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(6) 사용자는 대관한 장소 및 설비에 변경을 가하거나 특별한 장비를 반입하여 설치할 경우 사전 승인을 받아서 설치하며, 시설 사용을 완료하거나 중단하였을 때에는 바로 반입 설비를 철거, 원상복구한 후 센터 대관 담당자의 확인을 받아야 한다.</li>
	              <li>&nbsp;&nbsp;&nbsp;&nbsp;(7) 상기 사항 미준수 시는 시설 사용을 금지 또는 제한할 수 있으며 이로 인한 손해, 손실은 센터에서 책임지지 않는다.</li>
	            </ul>
			</div>
		</div>
		<!-- //금천50플러스센터 시설대관운영지침 -->
		
		<div v-else>
			<label class="block-input-label">공간이용규정 동의</label>
			<!-- 포털(fpp) 공간이용규정 -->
			<div class="text-area-box" v-if="isPortal">
				<p class="area-box__middle-section">1. 배상책임</p>
				<ul>
					<li>① 규칙에 의거하여 시설의 사용을 제한·취소할 경우, 사용자에게 손해가 있을지라도 캠퍼스는 그 배상책임을 지지 않습니다.</li>
					<li>② 시설 사용과 관련하여 발생한 사고에 대해서는 사용자가 민·형사상의 모든 책임을 집니다. 다만, 캠퍼스의 지시를 이행하였거나 캠퍼스와 사전 협의한 후 장치 및 시설물 등을 설치하여 사고가 발생한 경우에는 캠퍼스와 사용자가 책임한계를 협의하여 정합니다.</li>
				</ul>
				<p class="area-box__middle-section">2. 사용자의 준수사항</p>
				<ul>
					<li>① 사용자는 사용기간 중 시설 등에 대하여 선량한 관리자로서의 의무를 다하여야 합니다.</li>
					<li>② 사용자가 관리의무를 태만히 하여 시설 등을 훼손하였을 때에는 훼손시설에 상당하는 손해배상을 하여야 합니다.</li>
					<li>③ 사용자는 캠퍼스의 동의없이 그 권리를 양도하거나 전대할 수 없습니다.</li>
				</ul>
				<p class="area-box__middle-section">3. 사용 취소 신청 및 환불</p>
				<ul>
					<li>① 사용자가 시설 사용을 취소하고자 할 경우 마이페이지에서 사용 신청을 취소해야 합니다.</li>
					<li>② 캠퍼스는 다음에 따라 사용료를 환불합니다.</li>
					<li>- 사용개시일 당일 : 환불불가</li>
					<li>- 사용개시일 전일까지 : 전액환불</li>
				</ul>
			</div>
			<!-- 그 외 캠퍼스/센터 공간이용규정 -->
			<div class="text-area-box" v-else>
				<p class="area-box__middle-section">1. 배상책임</p>
				<ul>
					<li>① 규칙에 의거하여 대관시설의 사용을 제한·취소할 경우, 대관자에게 손해가 있을지라도 캠퍼스는 그 배상책임을 지지 않습니다.</li>
					<li>② 대관과 관련하여 발생한 사고에 대해서는 대관자가 민·형사상의 모든 책임을 집니다. 다만, 캠퍼스의 지시를 이행하였거나 캠퍼스와 사전 협의한 후 장치 및 시설물 등을 설치하여 사고가 발생한 경우에는 캠퍼스와 대관자가 책임한계를 협의하여 정합니다.</li>
				</ul>
				<p class="area-box__middle-section">2. 대관자의 준수사항</p>
				<ul>
					<li>① 대관자는 사용기간 중 시설 등에 대하여 선량한 관리자로서의 의무를 다하여야 합니다.</li>
					<li>② 대관자가 관리의무를 태만히 하여 시설 등을 훼손하였을 때에는 훼손시설에 상당하는 손해배상을 하여야 합니다.</li>
					<li>③ 대관자는 캠퍼스의 동의없이 그 권리를 양도하거나 전대할 수 없습니다.</li>
				</ul>
				<p class="area-box__middle-section">3. 대관 취소 신청 및 환불</p>
				<ul>
					<li>① 대관자가 대관을 취소하고자 할 경우 대관취소신청서를 작성하여 캠퍼스에 제출하여야합니다.</li>
					<li>② 캠퍼스는 다음에 따라 사용료를 환불합니다.</li>
					<li>- 사용개시일 당일 : 환불불가</li>
					<li>- 사용개시일 전일까지 : 전액환불</li>
				</ul>
			</div>
	    </div>
		<div class="text-right">
          <label class="checkbox-inline progress-label__agree-ckeck">
            <input class="input__checkbox" type="checkbox" v-model="agree2" title="약관동의 체크박스"> 동의
          </label>
        </div>
      </div>
      <div class="form-submit-gruop">
          <button type="submit" class="form-submit__btn line-btn--red" @click="goToStep2">이전</button>
          <button type="submit" class="form-submit__btn btn--blue-line" @click="checkReady">{{ txt.regButton }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  
  export default {
    components: { Datepicker },
    name: 'booking-form',
    props: ['room', 'member', 'roomItems', 'communities', 'applyDate', 'strtTime', 'cost', 'exchange', 'siteCode'],
    data() {
      return {
        step: 1,
        booking: {
          roomId: this.room.id,
          representative: {
            name: '',
            phone: '',
            email: '',
          },
          date: '',
          startTime: null,
          endTime: null,
          groupName: '',
          communityId: null,
          purpose: '',
          personnel: null,
          items: [],
          totalCost: 0,
          files: [],
        },
        date: null,
        selectedItem: 0,
        optionItems: [],
        communityPlus: this.room.status === 'COMMUNITY',
        isPlus: this.room.isPlus,
        checkPlus: false,
        agree2: false,
        progressing: false,
        count: 0,
        exCost: 0,
        state: {
          disabled: {
            days: [0],
            to: new Date(Date.now() + (24 * 60 * 60 * 1000)),
          },
        },
        statePlus: {
          disabled: {
            days: [0],
            to: new Date(Date.now() + (24 * 60 * 60 * 1000)),
            from: new Date(Date.now() + (720 * 60 * 60 * 1000)),
          },
        },
        communitieList: null,
        dateSt: null,
      };
    },
    computed: {
      isPortal() {
        return this.siteCode === 'fpp';
      },
      txt() {
        const p = this.isPortal;
        return {
          info: p ? '신청정보' : '대관정보', // step2 탭
          act: p ? '사용' : '대관', // "~확정은..."
          cost: p ? '사용료' : '대관비용', // 비용 라벨
          purpose: p ? '사용목적' : '대관목적', // 목적 라벨
          regButton: p ? '사용신청' : '대관신청등록', // 등록 버튼
        };
      },
      costTitle() {
        if (this.cost.length === 0) return '기본비용';
        return this.txt.cost;
      },
      selectedItemCost() {
        if (this.roomItems.length === 0) return '';
        return this.roomItems[this.selectedItem].cost;
      },
      ttlCost() {
        const itemCost = this.optionItems.map(x => x.cost).reduce((x, y) => x + y, 0);
        this.booking.totalCost = itemCost + this.exCost;
      },
      addtionalCost() {
        return this.optionItems.map(x => x.cost).reduce((x, y) => x + y, 0);
      },
      url() {
        return `/api/comments/${this.postId}`;
      },
      bookingDate() {
        if (!this.dateSt || !this.booking.startTime || !this.booking.endTime) return '';
        return `${this.dateSt.substr(0, 10)} ${this.booking.startTime.substr(0, 2)}:${this.booking.startTime.substr(2, 2)} ~ ${this.booking.endTime.substr(0, 2)} : ${this.booking.endTime.substr(2, 2)}`;
      },
    },
    mounted() {
      if (this.applyDate.length === 8 && this.strtTime.length === 4) {
        const yy = this.applyDate.substr(0, 4);
        const mm = this.applyDate.substr(4, 2);
        const dd = this.applyDate.substr(6, 2);
        this.date = new Date(parseInt(yy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10), 12, 0, 0, 0);
        this.booking.startTime = this.strtTime;
      }
      if (this.cost.length === 0) {
        this.exCost = this.room.cost;
        this.booking.totalCost = this.room.cost;
      }
      if (this.communityPlus === true) {
        this.checkPlus = true;
      }
      document.title = '시설 사용신청|기본정보|서울시 50플러스포털';
    },
    updated() {
      if (this.count === 1) {
        $('#date').focus();
        this.count += 1;
      }
    },
    methods: {
      checkNumber() {
        if (!this.integerFormmatter(this.booking.personnel)) {
          this.booking.personnel = 0;
        }
        if (this.booking.personnel.length > 8) {
          this.booking.personnel = this.booking.personnel.substring(0, 8);
        }
      },
      imgUrlChange() {
        const that = this;
        const fileName = document.getElementById('bookingFile01').files[0].name;
        const fileSize = document.getElementById('bookingFile01').files[0].size;
        if (((fileSize / 1024) / 1024).toFixed(4) >= 2) {
          alert('첨부파일은 최대 2MB 사이즈 까지만 업로드가 가능합니다.');
          return;
        }
        $('#formBookingFile01').ajaxSubmit({
          dataType: 'json',
          error: (err) => {
            alert(err.responseJSON.msg);
          },
          success: (response, statusText, xhr) => {
            if (xhr.status === 401) {
              alert('로그아웃 상태입니다.');
              location.href = '/login.do';
            } else if (xhr.status < 400) {
              that.booking.files.push({
                seq: that.booking.files.length,
                filename: fileName,
                fileUrl: response.filename,
              });
            } else {
              alert(statusText);
            }
          },
        });
      },
      integerFormmatter(txt) {
        const idReg = /^[-]?\d+$/;
        return idReg.test(txt);
      },
      setBookingDate() {
        if (this.date != null && this.booking.startTime != null && this.booking.endTime != null) {
          this.costCalc();
        }
      },
      costCalc() {
        const sttm = this.booking.startTime;
        const edtm = this.booking.endTime;
        const weekNum = this.date.getDay();
        let STHHTM = 0;
        let STMMTM = 0;
        let EDHHTM = 0;
        let EDMMTM = 0;
        let EX_PER = 0;
        if (this.exchange.length > 0) {
          for (let i = 0; i < this.exchange.length; i += 1) {
            if (this.exchange[i].WEEK === weekNum) {
              if (this.exchange[i].STHHTM !== '') STHHTM = this.exchange[i].STHHTM;
              if (this.exchange[i].STMMTM !== '') STMMTM = this.exchange[i].STMMTM;
              if (this.exchange[i].EDHHTM !== '') EDHHTM = this.exchange[i].EDHHTM;
              if (this.exchange[i].EDMMTM !== '') EDMMTM = this.exchange[i].EDMMTM;
              if (this.exchange[i].EX_PER !== '') EX_PER = this.exchange[i].EX_PER;
              break;
            }
          }
        }
        // 대관설정시간
        const stMin = parseInt(sttm.substring(0, 2) * 60, 10) + parseInt(sttm.substring(2, 4), 10);
        const edMin = parseInt(edtm.substring(0, 2) * 60, 10) + parseInt(edtm.substring(2, 4), 10);
        const bookingMin = parseInt(edMin, 10) - parseInt(stMin, 10);

        // 할증시간
        const stExMin = parseInt(STHHTM * 60, 10) + parseInt(STMMTM, 10);
        const edExMin = parseInt(EDHHTM * 60, 10) + parseInt(EDMMTM, 10);

        // 대관시간중 할증시간
        const exMin1 = parseInt(edMin, 10) - parseInt(stExMin, 10);
        let exMin2 = parseInt(edMin, 10) - parseInt(edExMin, 10);
        if (exMin2 < 0) exMin2 = 0;
        let exMin = parseInt(exMin1, 10) - parseInt(exMin2, 10);
        if (exMin < 0) exMin = 0;

        let ss = 0;
        let ee = 0;

        // 대관신청 시작시간 : stMin 11
        // 대관신청 종료시간 : edMin 18
        // 대관할증 시작시간 : stExMin 13
        // 대관할증 종료시간 : edExMin 17

        if (stMin < stExMin) {
          ss = stExMin;
        } else if (stMin >= stExMin) {
          ss = stMin;
        }

        if (edMin < edExMin) {
          ee = edMin;
        } else if (edMin >= edExMin) {
          ee = edExMin;
        }

        if (edMin < stExMin || stMin > edExMin) {
          ss = 0;
          ee = 0;
        }

        // 신청시간
        const noCostPri = parseInt(bookingMin, 10);
        // 할증시간
        const exCostPri = ee - ss;
        // 할증 제외한 시간
        const noExCostPri = noCostPri - exCostPri;

        let EX_COST = 0;
        let NOEX_COST = 0;
        let EX_COST_PLUS = 0;
        let FINAL_COST = 0;
        let PRICE = 0;
        if (this.cost.length > 0) {
          for (let i = 0; i < this.cost.length; i += 1) {
            if (this.cost[i].MIN === noCostPri) {
              if (exCostPri > 0) {
                // 할증금액을 제외한 금액
                PRICE = this.cost[i].COST;
                NOEX_COST = PRICE * (noExCostPri / noCostPri);
                // 할증금액
                EX_COST = PRICE * (exCostPri / noCostPri);
                EX_COST_PLUS = PRICE * (exCostPri / noCostPri) * (EX_PER / 100);
                FINAL_COST = NOEX_COST + EX_COST + EX_COST_PLUS;
              } else {
                FINAL_COST = this.cost[i].COST;
              }
            }
          }
        } else {
          this.exCost = this.room.cost;
          return;
        }
        this.exCost = Math.floor(Math.floor(FINAL_COST) / 100) * 100;
      },
      groupNameValidate() {
        if (this.booking.groupName.length > 30) {
          alert(`단체명이 ${this.booking.groupName.length}자입니다.`);
        }
      },
      chkinfo() {
        if ($('input:checkbox[id="chkinfoId"]').is(':checked') === true) {
          this.booking.representative.name = this.member.name;
          this.booking.representative.phone = this.member.phone.replace(/-/g, '');
          this.booking.representative.email = this.member.email;
        } else if ($('input:checkbox[id="chkinfoId"]').is(':checked') === false) {
          this.booking.representative.name = '';
          this.booking.representative.phone = '';
          this.booking.representative.email = '';
        }
      },
      goToStep1() {
        this.step = 1;
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        document.title = '시설 사용신청|기본정보|서울시 50플러스포털';
      },
      goToStep2() {
        if (this.progressing) return;
        if (this.step === 1) {
          if (this.booking.representative.name.length === 0) {
            alert('대표자 이름을 입력해 주세요.');
            return;
          } else if (this.booking.representative.phone.length === 0) {
            alert('대표자 연락처를 입력해 주세요.');
            return;
          } else if (!this.globalIntegerFormmatter(this.booking.representative.phone)) {
            alert('대표자 연락처를 숫자로 입력해 주세요.');
            return;
          } else if (this.booking.representative.email.length === 0) {
            alert('대표자 이메일을 입력해 주세요.');
            return;
          } else if (!this.globalEmailFormatter(this.booking.representative.email)) {
            alert('이메일 형식에 맞게 입력해 주세요.');
            return;
          }
        }
        document.title = '시설 사용신청|신청정보|서울시 50플러스포털';
        this.step = 2;
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        this.count = 0;
        this.count += 1;
        setTimeout(() => {
          document.getElementById('date').readOnly = false;
          document.getElementById('date').placeholder = 'OOOO-OO-OO';
          document.getElementById('date').title = 'OOOO-OO-OO';
          $('#date').css('color', 'transparent');
          $('#date').css('text-shadow', '0 0 0 #2c2c2c');
        }, 500);
      },
      goToStep3() {
        this.dateSt = document.getElementById('date').value;
        if (this.step === 2) {
          if (!this.dateSt || this.booking.startTime === null || this.booking.endTime === null ||
            this.booking.startTime >= this.booking.endTime) {
            alert('대관 일시를 확인해 주세요.');
            return;
          }
          if (this.booking.groupName.length === 0) {
            alert('단체명을 입력해 주세요.');
            return;
          }
          if (this.booking.groupName.length > 30) {
            alert('단체명을 30자 이하로 입력해 주세요.');
            return;
          }
          if (this.checkPlus && this.booking.communityId === '') {
            alert('커뮤니티를 선택해 주세요.');
            return;
          }
          if (this.booking.purpose.length === 0) {
            alert('대관 목적을 입력해 주세요.');
            return;
          }
          if (!this.booking.personnel || this.booking.personnel <= 0) {
            alert('사용인원을 입력해 주세요.');
            return;
          }
          if (this.booking.personnel.length > 8) {
            alert('사용인원을 확인해 주세요.(최대 99,999,99까지 입력 가능합니다.)');
            return;
          }
          if (!this.globalIntegerFormmatter(this.booking.personnel)) {
            alert('사용인원을 숫자로 입력해 주세요.');
            return;
          }
        }
        const dtRe = this.dateSt.split('-').join('');
        const befor = String(moment(this.today).add(2, 'days').format('YYYYMMDD'));
        const after = String(moment(this.today).add(30, 'days').format('YYYYMMDD'));
        if (this.communityPlus || (this.checkPlus && this.isPlus)) {
          if (parseInt(befor, 10) > parseInt(dtRe, 10) || parseInt(after, 10) < parseInt(dtRe, 10)) {
            alert('일시는 최소 2일 ~ 30일 이내에 대관이 가능합니다.');
            $('#date').focus();
            return;
          }
        } else if (!this.communityPlus) {
          if (parseInt(befor, 10) > parseInt(dtRe, 10)) {
            alert('최소 2일전부터 대관이 가능합니다.');
            $('#date').focus();
            return;
          }
        }
        const confirmResult = window.confirm(`기관 : ${this.room.org}\n공간 : ${this.room.name}\n일시 : ${this.dateSt} ${this.booking.startTime.substr(0, 2)}:${this.booking.startTime.substr(2, 2)} ~ ${this.booking.endTime.substr(0, 2)}:${this.booking.endTime.substr(2, 2)}\n\n 위 내용으로 진행 하시겠습니까?`);
        if (!confirmResult) {
          return;
        }
        document.title = '시설 사용신청|등록|서울시 50플러스포털';
        this.step = 3;
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
      },
      addItem() {
        this.optionItems.push(this.roomItems[this.selectedItem]);
      },
      delItem(index) {
        this.optionItems.splice(index, 1);
        $('#addBtn').focus();
      },
      getTimeValue(index) {
        const HH = Math.ceil(index / 2) + 8;
        const mm = index % 2 === 1 ? '00' : '30';

        return `${HH < 10 ? '0' : ''}${HH}${mm}`;
      },
      selectedCommunity() {
        this.booking.communityId = '';
        if (!this.communitieList) {
          this.booking.groupName = '';
          return;
        }
        if (this.checkPlus && this.communitieList.rsttCnt > 2) {
          alert('해당 커뮤니티는 커뮤니티플러스 공간신청 제한 상태 입니다.');
          this.communitieList = null;
          return;
        }
        this.booking.communityId = this.communitieList.id;
        this.booking.groupName = this.communities
          .find(community => community.id === this.booking.communityId).name;
      },
      changeCheckPlus() {
        this.booking.communityId = '';
        if (!this.communitieList) {
          this.booking.groupName = '';
          return;
        }
        if (this.checkPlus && this.communitieList.rsttCnt > 2) {
          alert('해당 커뮤니티는 커뮤니티플러스 공간신청 제한 상태 입니다.');
          this.communitieList = null;
          return;
        }
        this.booking.communityId = this.communitieList.id;
        this.booking.groupName = this.communities
          .find(community => community.id === this.booking.communityId).name;
      },
      apply() {
        axios.post(`/api/bookings?org=${this.room.orgCode}`, this.booking).then(() => {
          this.progressing = false;
          alert('시설 사용신청이 완료되었습니다.');
          location.href = '/mypage-booking.do';
          this.progressing = false;
        }).catch((e) => {
          // console.dir(e);
          this.progressing = false;
          if (e.response.status === 400) {
            alert(e.response.data.msg);
          } else {
            location.reload();
          }
        });
      },
      checkReady() {
        if (!this.date) {
          alert('이전 단계에서 달력을 클릭하여 일시를 입력해주세요.');
          return;
        }
        if (this.progressing) return;
        if (!this.agree2) {
          alert('공간이용규정에 동의해 주세요.');
          return;
        }
        this.progressing = true;
        if (!this.checkPlus) this.booking.communityId = null;
        this.booking.date = this.dateSt.substr(2, 8).split('-').join('');
        this.booking.items = this.optionItems.map((item, index) => {
          const newItem = {
            seq: index,
            name: item.name,
            cost: item.cost,
          };
          return newItem;
        });
        axios.post(`/api/bookings/checkReady?org=${this.room.orgCode}`, this.booking).then((response) => {
          if (response.data === false) {
            const confirmResult = window.confirm('해당 시간대는 대관신청중 입니다.\n계속 진행하시겠습니까?');
            if (confirmResult) {
              this.apply();
            } else {
              this.progressing = false;
            }
          } else {
            this.apply();
          }
        }).catch((e) => {
          this.progressing = false;
          if (e.response.status === 400) {
            alert(e.response.data.msg);
          } else {
            location.reload();
          }
        });
      },
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// BookingForm.vue?5870c4e4